import React from 'react'
import './footer.css'

export default function Footer() {
    return (
        <footer>
            <small className="copyright">© <a href="https://martincosimano.github.io/portfolio/">Martin Cosimano</a>.</small>
        </footer>
    )
}



// WEBPACK FOOTER //
// ./src/components/Footer.js